module.exports = __webpack_public_path__ + "img/secondopinion_jumbotron.29b8bc05.png";